import Component, { Topic } from 'component';
import { assert } from 'utils';

export const FOR_ATTR = 'for';              // id della grid target
export const SIDE_PAGE_ATTR = 'side-page';              // pages to display around current page
export const SHOW_START_ATTR = 'show-start-pages';              // starting pages always to dispay
export const SHOW_LAST_ATTR = 'show-last-pages';              // ending pages always to dispay

/* =====================================================================================
   <x-paginator>  —  controlla la grid target (attributo for="grid-id")
   Pubblica PAGE_NEXT / PAGE_PREV; reagisce a REACH_START / REACH_END per disabilitare
   e a PAGE_CHANGE / PAGINATION_INFO per evidenziare la pagina corrente.
===================================================================================== */
customElements.define('x-article-grid-paginator', class extends Component {
  #forId = '';
  #articleGridComponent = null;
  #prevBtn;
  #nextBtn;
  #pages = [];
  #current = 1;
  #total = null;
  #sidePage;
  #startingPageTreshold;
  #endingPageTreshold;
  
  static get observedAttributes() {
    return [FOR_ATTR, SIDE_PAGE_ATTR, SHOW_START_ATTR, SHOW_LAST_ATTR];
  }

  constructor() {
    super();
    const wrap = document.createElement('nav');
    wrap.className = 'x-paginator__wrap';
    this.appendChild(wrap);
    this.#wireSubscriptions();
    this.$element = this.querySelector(".x-paginator__wrap")

    this.#forId = (this.getAttribute(FOR_ATTR) || '').trim();
    assert(this.#forId, `[x-article-grid-paginator] Missing '${FOR_ATTR}' attribute (must point to <x-article-grid id="...">)`);

    this.#articleGridComponent = document.getElementById(this.#forId)
    assert(this.#articleGridComponent, `[x-article-grid-paginator] Missing parent <x-article-grid id="${this.#forId}">)`);

    this.#sidePage = parseInt(this.getAttribute(SIDE_PAGE_ATTR) || "1")
    this.#startingPageTreshold = parseInt(this.getAttribute(SHOW_START_ATTR) || "1")
    this.#endingPageTreshold = parseInt(this.getAttribute(SHOW_LAST_ATTR) || "1") - 1
  }


  async attributeChangedCallback(name, oldVal, newVal) {
    // Forzare ridisegno all’aggiornamento del target
    if (oldVal !== newVal) {
      await customElements.whenDefined('x-article-grid');
      this.#total = this.#articleGridComponent.getTotalPages();
      this.#draw(this.#current);
    }
  }

  #wireSubscriptions() {
    // Ricevi info pagine (per costruire i bottoni)
    this.sub(Topic.BLOG_PAGINATION_INFO, ({ targetId, currentPage, totalPages }) => {
      if (targetId !== this.#forId) return;

      this.#current = currentPage;
      this.#highlight(currentPage);
      this.#total = totalPages;

      this.#draw(this.#current);
    }, { global: true });

    // Limiti
    this.sub(Topic.BLOG_REACH_START, ({ targetId }) => {
      if (targetId !== this.#forId) return;
      this.#updateEnds({ atStart: true });
    }, { global: true });

    this.sub(Topic.BLOG_REACH_END, ({ targetId }) => {
      if (targetId !== this.#forId) return;
      this.#updateEnds({ atEnd: true });
    }, { global: true });
  }

  #draw(current) {
    this.$element.innerHTML = '';
    this.#pages = [];
    const total = this.#articleGridComponent.getTotalPages();

    // Prev
    this.#prevBtn = document.createElement('button');
    this.#prevBtn.type = 'button';
    this.#prevBtn.className = 'prev pag-nav';
    this.#prevBtn.textContent = '‹';
    this.on(this.#prevBtn, 'click', () => {
      this.pub(Topic.BLOG_PAGE_PREV, { targetId: this.#forId }, { global: true });
    });
    this.$element.appendChild(this.#prevBtn);

    /* =====================  SOSTITUISCI QUESTO BLOCCO  =====================
     Invece del loop 1..total, generiamo la lista con ellissi: [1, 2, 3, '…', 14]
     ====================================================================== */
    const items = (() => {
      const range = [];
      const out = [];
      let last;

      for (let i = 1; i <= total; i++) {
        if (
          // i === 1 || i === total ||         // sempre prima/ultima
          i <= this.#startingPageTreshold || i >= total - this.#endingPageTreshold ||       // prime e ultime pagine da mostrare sempre
          (i >= current - this.#sidePage && i <= current + this.#sidePage) // intorno alla pagina corrente
        ) {
          range.push(i);
        }
      }

      for (const i of range) {
        if (last) {
          if (i - last === 2) out.push(last + 1); // se ce uno scarto di solo 2 inserito il numero di pagina invece dell'ellissi
          else if (i - last > 2) out.push('…');   // buco >1 → ellissi
        }
        out.push(i);
        last = i;
      }

      return out.filter((v, idx, arr) => !(v === '…' && arr[idx - 1] === '…'));
    })();

    this.$element.classList.toggle('d-none', items.length === 1);

    items.forEach((it) => {
      if (it === '…') {
        const sep = document.createElement('span');
        sep.className = 'page page--ellipsis';
        sep.textContent = '…';
        this.$element.appendChild(sep);
        return;
      }

      const i = Number(it);
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `page`;
      b.textContent = String(i);

      // stato attivo/disabilitato
      if (i === current) {
        b.classList.add('is-active');
        // b.disabled = true;
        b.setAttribute('aria-current', 'page');
      }

      this.on(b, 'click', () => {
        // manteniamo l’attuale logica: emettiamo NEXT/PREV in serie fino alla pagina richiesta
        const delta = i - this.#current;
        if (delta > 0) {
          for (let k = 0; k < delta; k++)
            this.pub(Topic.BLOG_PAGE_NEXT, { targetId: this.#forId }, { global: true });
        }
        else if (delta < 0) {
          for (let k = 0; k < Math.abs(delta); k++)
            this.pub(Topic.BLOG_PAGE_PREV, { targetId: this.#forId }, { global: true });
        }
      });

      this.$element.appendChild(b);
      this.#pages.push(b);
    });
    /* ===================  FINE BLOCCO SOSTITUITO  =================== */

    // Next
    this.#nextBtn = document.createElement('button');
    this.#nextBtn.type = 'button';
    this.#nextBtn.className = 'next pag-nav';
    this.#nextBtn.textContent = '›';
    this.on(this.#nextBtn, 'click', () => {
      this.pub(Topic.BLOG_PAGE_NEXT, { targetId: this.#forId }, { global: true });
    });
    this.$element.appendChild(this.#nextBtn);

    // Stato iniziale
    this.#highlight(current);
    this.#updateEnds({ atStart: current === 1, atEnd: current === total });
  }

  #highlight(current) {
    this.#pages.forEach((btn, idx) => {
      btn.classList.toggle('is-active', btn.getAttribute("aria-current") ?? false);
    });
  }

  #updateEnds({ atStart = undefined, atEnd = undefined } = {}) {
    if(atStart != undefined){
      if (this.#prevBtn) this.#prevBtn.disabled = !!atStart;
    }
    if(atEnd != undefined){
      if (this.#nextBtn) this.#nextBtn.disabled = !!atEnd;
    }
  }
});